import { DisplayPosition } from '@/common/manager/position/display-position';
import React from 'react';
import { CnImageViewer } from '@cainiaofe/cn-ui';
import './image-viewer.scss';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'ImageViewer',
    formComponent: (props) => {
        const { value, width, height } = props || {};
        return (<CnImageViewer className={'cn-image-viewer-alc'} src={value} width={width} height={height}/>);
    },
};
